import React from "react";
import { TooltipBootrap } from "components/GenericComponent/TooltipBootrap";

export const ContentTable = () => {
  return (
    <>
      <div className="custom-table-row" key={"item" + 1}>
        <div className="custom-table-cell flex-basis-16 flex-basis-15-6-sm">
          <span className="mobile-column-name">Tên khách hàng</span>
          <div className="center-wrapper">
            <p className="text-left">
              Nguyễn Văn A<br />
              (ĐT: 0912.536.085)
            </p>
          </div>
        </div>

        <div className="custom-table-cell flex-basis-12 flex-basis-11-8-sm">
          <span className="mobile-column-name">Số CCCD</span>
          <div className="center-wrapper">
            <p className="text-left">0123456789</p>
          </div>
        </div>

        <div className="custom-table-cell flex-basis-17 flex-basis-15-6-sm">
          <span className="mobile-column-name">Tên cửa hàng</span>
          <div className="center-wrapper">
            <p className="text-left">
              Cầm đồ 678
              <br />
              (ĐT: 0912.999.999)
            </p>
          </div>
        </div>

        <div className="custom-table-cell flex-basis-11 flex-basis-10-sm">
          <span className="mobile-column-name">Kiểu vay</span>
          <div className="center-wrapper">
            <p className="text-center">Tín chấp</p>
          </div>
        </div>

        <div className="custom-table-cell flex-basis-11 flex-basis-11-sm">
          <span className="mobile-column-name">Số tiền vay</span>
          <div className="center-wrapper">
            <p className="text-right">
              <span className="red">5,000,000</span>
            </p>
          </div>
        </div>

        <div className="custom-table-cell flex-basis-10 flex-basis-11-sm">
          <span className="mobile-column-name">Tình trạng</span>
          <div className="center-wrapper">
            <p className="text-center">
              <span className="canh-bao-red">Nợ xấu</span>
            </p>
          </div>
        </div>

        <div className="custom-table-cell flex-basis-10 flex-basis-10-sm ">
          <span className="mobile-column-name">Trạng thái</span>
          <div className="center-wrapper">
            <p className="text-center">
              <span className="canh-bao-red">Quá hạn</span>
            </p>
          </div>
        </div>

        <div className="custom-table-cell flex-basis-13 flex-basis-15-sm">
          <span className="mobile-column-name">Ảnh</span>
          <div className="center-wrapper">
            <p className="text-center ava-kh">
              <TooltipBootrap
                contentText={
                  <div>
                    <img src="/app-assets/images/no_image.png" alt="" />
                  </div>
                }
                titleText=""
                trigger={["hover", "focus"]}
                placement={"left"}
              >
                <a href={() => false}>
                  <img
                    className="img-responsive"
                    src="/app-assets/images/no_image.png"
                    alt=""
                  />
                </a>
              </TooltipBootrap>
            </p>
          </div>
        </div>
      </div>
    </>
  );
};
